import { MedicalType } from "@qendo/medical/types";
import {
    basicViewPermission,
    type MedicalPermissionSection,
    type ReadOnlyProfilePermissions,
    type Section,
} from "@qendo/permissions";
import { TrackableType } from "@qendo/trackables";
import { OptionType } from "@qendo/types";
import { Permissions } from "~/entities/profile/permissions";

export function journalPermissionSection(type: TrackableType): Section {
    switch (type) {
        case TrackableType.activity:
            return "activities";
        case TrackableType.symptom:
            return "symptoms";
        default:
            return "journal";
    }
}

export const medicalPermissionSection = (type: MedicalType): Section => {
    switch (type) {
        case MedicalType.allergy:
            return "allergies";
        case MedicalType.condition:
            return "conditions";
        case MedicalType.immunisation:
            return "immunisations";
        case MedicalType.medication:
            return "medications";
        case MedicalType.past_symptom:
            return "past_symptoms";
        case MedicalType.supplement:
            return "supplements";
        case MedicalType.surgery:
            return "surgeries";
        case MedicalType.trigger:
            return "triggers";
        default:
            return "medical";
    }
};
export const optionPermissionSection = (type: OptionType): Section => {
    switch (type) {
        case OptionType.calendar_events:
            return "calendar";
        case OptionType.allergies:
        case OptionType.conditions:
        case OptionType.immunisations:
        case OptionType.medications:
        case OptionType.past_symptoms:
        case OptionType.supplements:
        case OptionType.surgeries:
        case OptionType.triggers:
            return type as MedicalPermissionSection;
        case OptionType.team_members:
            return "team";
        case OptionType.activities_bathings:
        case OptionType.activities_exercises:
        case OptionType.activities_exercise_durations:
        case OptionType.activities_flight_durations:
        case OptionType.activities_sex_positions:
        case OptionType.activities_sex_results:
        case OptionType.activities_tens:
            return "activities";
        case OptionType.symptoms_acne_locations:
        case OptionType.symptoms_bleedings:
        case OptionType.symptoms_bleeding_colours:
        case OptionType.symptoms_bowel_activities:
        case OptionType.symptoms_discharges:
        case OptionType.symptoms_headaches:
        case OptionType.symptoms_ovulations:
        case OptionType.symptoms_symptom_durations:
        case OptionType.symptoms_symptom_locations:
        case OptionType.symptoms_pain_types:
        case OptionType.symptoms_treatments:
        case OptionType.symptoms_urine_colours:
            return "symptoms";
        default:
            return "medical";
    }
};

export function makeSharePermissions(sections?: Section[] | null): ReadOnlyProfilePermissions {
    return new Permissions(
        Object.fromEntries((sections ?? []).map((section) => [section, basicViewPermission])),
    ) as ReadOnlyProfilePermissions;
}
